<div *ngIf="message" class="container">
    <div class="col-sm-8 offset-sm-2 m-t-40 center">
    	<div [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">{{message.text}}</div>
    </div>
</div>